import React, { Component } from 'react';

class Form extends Component {

  setData = e => {
    this.props.setData(e);
  }

  render() {
    return (
      <div className="form-data">
        <div className="form-group">
          <div className="form-row">
            <label htmlFor="artist_name">Artist name *</label>
            <input type="text" name="artist_name" id="artist_name" onChange={this.setData} placeholder="The Trolling Phones" required/>
          </div>
          <div className="form-row">
            <label htmlFor="email">Email *</label>
            <input type="email" name="email" id="email" onChange={this.setData} placeholder="john@example.com" required/>
          </div>
          <div className="form-row half-container">
            <div className="form-row name-first">
              <label htmlFor="name_first">Firstname *</label>
              <input type="text" name="name_first" id="name_first" onChange={this.setData} placeholder="John" />
            </div>
            <div className="form-row">
              <label htmlFor="name_last">Lastname *</label>
              <input type="text" name="name_last" id="name_last" onChange={this.setData} placeholder="Doe" />
            </div>
          </div>
          <div className="form-row">
            <label htmlFor="phonenumber">Phonenumber</label>
            <input type="tel" name="phonenumber" id="phonenumber" onChange={this.setData} placeholder="+1 202 555-0148"/>
          </div>
          <div className="form-row">
            <label htmlFor="website">Website</label>
            <input type="text" name="website" id="website" onChange={this.setData} placeholder="www.website.com"/>
          </div>
          <div className="form-row last">
            <label htmlFor="findout">How did you find out about ABOSS?</label>
            <input name="findout" id="findout" onChange={this.setData} placeholder="Referral name / Google / Other "/>
          </div>
        </div>
      </div>
    );
  }
}

export default Form;


// WEBPACK FOOTER //
// src/views/trial/form.js